<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <g id="Groupe_7" data-name="Groupe 7" transform="translate(-113 -844.5)">
            <circle id="Ellipse_4" data-name="Ellipse 4" cx="12" cy="12" r="12" transform="translate(113 844.5)" fill="red" />
            <path id="Polygone_4" data-name="Polygone 4" d="M6,0l6,10H0Z" transform="translate(131 850.5) rotate(90)" fill="#fff" />
        </g>
    </svg>
</template>

<script>
export default {
    name: "Play",
};
</script>
